import { print } from "graphql";
import gql from "graphql-tag";

import {
  articleExtended,
  articleFragment,
  articleStubFragment,
  regulatoryPageFragment,
} from "./graphqlFields";

export const GetAllArticles = print(gql`
  query GetAllArticles(
    $where: ArticleFilter!
    $limit: Int!
    $preview: Boolean!
    $skip: Int!
  ) {
    collection: articleCollection(
      limit: $limit
      preview: $preview
      where: $where
      skip: $skip
    ) {
      total
      skip
      limit
      items {
        ...ArticleFields
      }
    }
  }
  ${articleFragment}
`);

export const GetAllArticleStubs = print(gql`
  query GetAllArticleStubs(
    $where: ArticleFilter!
    $limit: Int!
    $preview: Boolean!
    $skip: Int!
  ) {
    collection: articleCollection(
      limit: $limit
      preview: $preview
      where: $where
      skip: $skip
    ) {
      total
      skip
      limit
      items {
        ...ArticleStubFields
      }
    }
  }
  ${articleStubFragment}
`);

export const GetAllArticleSlugs = print(gql`
  query GetAllArticleSlugs(
    $where: ArticleFilter!
    $limit: Int!
    $preview: Boolean!
    $skip: Int!
  ) {
    collection: articleCollection(
      limit: $limit
      preview: $preview
      where: $where
      skip: $skip
    ) {
      total
      skip
      limit
      items {
        slug
      }
    }
  }
`);

export const GetArticle = print(gql`
  query GetArticle($preview: Boolean!, $where: ArticleFilter!) {
    collection: articleCollection(limit: 1, preview: $preview, where: $where) {
      total
      skip
      limit
      items {
        ...ArticleExtended
      }
    }
  }
  ${articleExtended}
`);

export const GetAllArticleSitemapEntries = print(gql`
  query GetAllArticleSitemapEntries(
    $where: ArticleFilter!
    $limit: Int!
    $preview: Boolean!
    $skip: Int!
  ) {
    collection: articleCollection(
      limit: $limit
      preview: $preview
      where: $where
      skip: $skip
    ) {
      total
      limit
      skip
      items {
        slug
        articleType {
          slug
        }
        sys {
          publishedAt
        }
      }
    }
  }
`);

export const GetRegulatoryPage = print(gql`
  query GetRegulatoryPage($where: RegulatoryPageFilter!, $preview: Boolean!) {
    collection: regulatoryPageCollection(
      limit: 1
      preview: $preview
      where: $where
    ) {
      total
      skip
      limit
      items {
        ...RegulatoryPageFields
      }
    }
  }
  ${regulatoryPageFragment}
`);

export const GetAllRegulatoryPages = print(gql`
  query GetAllRegulatoryPages(
    $where: RegulatoryPageFilter!
    $limit: Int!
    $preview: Boolean!
  ) {
    collection: regulatoryPageCollection(
      limit: $limit
      preview: $preview
      where: $where
    ) {
      total
      skip
      limit
      items {
        ...RegulatoryPageFields
      }
    }
  }
  ${regulatoryPageFragment}
`);

export const GetEditorsPickArticles = print(gql`
  query GetAllArticles(
    $where: ArticleFilter!
    $limit: Int!
  ) {
    collection: articleCollection(
      limit: $limit
      where: $where
    ) {
      total
      skip
      limit
      items {
        ...ArticleFields
      }
    }
  }
  ${articleFragment}
`);
